var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center"},[(!_vm.currentUserUpvoted)?_c('oz-icon',{class:_vm.isPadletColorSchemeDark ? 'text-light-text-300' : 'text-dark-text-300',attrs:{"name":"like_outline","size":20,"role":"button"},on:{"click":_vm.upvote}}):_vm._e(),_vm._v(" "),(_vm.currentUserUpvoted)?_c('oz-icon',{class:_vm.isPadletColorSchemeDark ? 'text-canary-500' : 'text-grape-500',attrs:{"name":"like_filled","size":20,"role":"button"},on:{"click":_vm.unvote}}):_vm._e(),_vm._v(" "),_c('span',{class:[
      'text-12-16',
      'font-sans',
      'ml-0.5',
      'mr-1',
      _vm.currentUserUpvoted
        ? _vm.isPadletColorSchemeDark
          ? 'text-light-text-200'
          : 'text-dark-text-200'
        : _vm.isPadletColorSchemeDark
        ? 'text-light-text-300'
        : 'text-dark-text-300' ]},[_vm._v(_vm._s(_vm.upvoteCount))]),_vm._v(" "),(!_vm.currentUserDownvoted)?_c('oz-icon',{class:_vm.isPadletColorSchemeDark ? 'text-light-text-300' : 'text-dark-text-300',attrs:{"name":"dislike_outline","size":20,"role":"button"},on:{"click":_vm.downvote}}):_vm._e(),_vm._v(" "),(_vm.currentUserDownvoted)?_c('oz-icon',{class:_vm.isPadletColorSchemeDark ? 'text-canary-500' : 'text-grape-500',attrs:{"name":"dislike_filled","size":20,"role":"button"},on:{"click":_vm.unvote}}):_vm._e(),_vm._v(" "),_c('span',{class:[
      'text-12-16',
      'font-sans',
      'ml-0.5',
      _vm.currentUserDownvoted
        ? _vm.isPadletColorSchemeDark
          ? 'text-light-text-200'
          : 'text-dark-text-200'
        : _vm.isPadletColorSchemeDark
        ? 'text-light-text-300'
        : 'text-dark-text-300' ]},[_vm._v(_vm._s(_vm.downvoteCount))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }